import React, { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { useNavigate } from "react-router-dom";
import { roleModel } from "../utils/definitions";
import { AppContext, Token, User } from "./app-context";

export const AppContextProvider = (props: { children: React.ReactNode }) => {
  // State definitions with explicit types

  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [userRole, setUserRole] = useState<string | null>(null);
  const [token, setToken] = useState<Token | null>(null);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [user, setUser] = useState<User | null>(null);
  const [companies, setCompanies] = useState<object[] | null>(null);
  const [companySubs, setCompanySubs] = useState<object[] | null>(null);
  const [locations, setLocations] = useState<object[] | null>(null);
  const [departments, setDepartments] = useState<object[] | null>(null);
  const [titles, setTitles] = useState<object[] | null>(null);
  const [users, setUsers] = useState<object[] | null>(null);
  const [leaveTypes, setLeaveTypes] = useState<object[] | null>(null);
  const [readers, setReaders] = useState<object[] | null>(null);

  const toast = useRef<any>(null);
  const toastTopCenter = useRef<any>(null);
  const toastCenter = useRef<any>(null);

  const IsMobileHandler = () => {
    //991.98px
    if (window.matchMedia("(max-width: 1199.98px)").matches) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  window.addEventListener("resize", IsMobileHandler);

  const CheckLogin = async () => {
    setLoader(true);
    let _token = localStorage.getItem("token");
    // console.log("token: ", _token);

    if (_token != null) {
      try {
        // Parse the token if it is not already parsed
        const parsedToken = JSON.parse(_token);
        // console.log("parsedToken: ", parsedToken);

        if (parsedToken?.accessToken) {
          setIsLoggedIn(true);
          //ParseJwt(parsedToken.accessToken);
          setToken(parsedToken);
        }
      } catch (error) {
        console.error("Error parsing token:", error);
      }
    }

    setLoader(false);
  };

  const IsLoggedInAsync = async () => {
    const token = localStorage.getItem("token");
    return token != null;
  };

  useEffect(() => {
    CheckLogin();
    IsMobileHandler();
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      // console.log("isLoggedIn: ", isLoggedIn);
      /* 
      //GetCompanies();
      //GetCompanySubs();
      //GetLocations();
      //GetDepartments();
      //GetTitles();
      //GetUsers();
      //GetLeaveTypes();
      if (userRole === roleModel.Admin || userRole === roleModel.Company) {
        //GetReaders();
      }*/
    }
  }, [isLoggedIn]);

  const GetCompanies = async () => {
    const response = await FetchHandler(
      "company",
      "get",
      null,
      null,
      isAdmin ? "admin" : ""
    );

    if (response.ok) {
      setCompanies(response.data);
    }
  };
  const GetCompanySubs = async () => {
    const response = await FetchHandler(
      "companySub",
      "get",
      null,
      null,
      isAdmin ? "admin" : ""
    );

    if (response.ok) {
      setCompanySubs(response.data);
    }
  };
  const GetLocations = async () => {
    const response = await FetchHandler(
      "location",
      "get",
      null,
      null,
      isAdmin ? "admin" : ""
    );

    if (response.ok) {
      setLocations(response.data);
    }
  };
  const GetDepartments = async () => {
    const response = await FetchHandler(
      "department",
      "get",
      null,
      null,
      isAdmin ? "admin" : ""
    );

    if (response.ok) {
      setDepartments(response.data);
    }
  };
  const GetTitles = async () => {
    const response = await FetchHandler(
      "title",
      "get",
      null,
      null,
      isAdmin ? "admin" : ""
    );

    if (response.ok) {
      setTitles(response.data);
    }
  };
  const GetUsers = async () => {
    const response = await FetchHandler(
      `user/list`,
      "post",
      null,
      null,
      isAdmin ? "admin" : ""
    );

    if (response.ok) {
      setUsers(response.data);
    }
  };
  const GetReaders = async () => {
    const response = await FetchHandler(
      `user/reader`,
      "get",
      null,
      null,
      isAdmin ? "admin" : ""
    );

    if (response.ok) {
      setReaders(response.data);
    }
  };
  const GetLeaveTypes = async () => {
    const response = await FetchHandler(
      `leaveType`,
      "get",
      null,
      null,
      isAdmin ? "admin" : ""
    );

    if (response.ok) {
      setLeaveTypes(response.data);
    }
  };

  const ParseJwt = (_token: string) => {
    const arrayToken = _token.split(".");
    const data = JSON.parse(decodeURIComponent(escape(atob(arrayToken[1]))));

    if (data !== "undefined" && data != null) {
      data.company = JSON.parse(data.company);
      data.companySub = JSON.parse(data.companySub);
      data.department = JSON.parse(data.department);
      data.title = JSON.parse(data.title);
      setUser(data);

      if (data.roles.includes(roleModel.Admin)) {
        setIsAdmin(true);
        setUserRole(roleModel.Admin);
      } else if (data.roles.includes(roleModel.Company)) {
        setUserRole(roleModel.Company);
      } else if (data.roles.includes(roleModel.DepartmentManager)) {
        setUserRole(roleModel.DepartmentManager);
      }
    }
  };

  const GetHeaders = (contentType: any, pageType?: string) => {
    switch (contentType) {
      case "formData":
        return {
          Authorization: `Bearer ${token?.accessToken}`,
          //AppName: pageType === "admin" ? "admin" : "client",
        };
      default:
        return {
          Authorization: `Bearer ${token?.accessToken}`,
          //AppName: pageType === "admin" ? "admin" : "client",
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
        } as Record<string, string>;
    }
  };

  const FetchHandler = async (
    url: string,
    method: string,
    contentType: string | null,
    data: BodyInit | null | undefined,
    pageType: string
  ) => {
    // console.log("inside fetchHandler");
    setLoader(true);
    return fetch(`${process.env.REACT_APP_BASE_URL}/api/${url}`, {
      method: method,
      mode: "cors",
      headers: GetHeaders(contentType, pageType),
      body: method === "get" ? null : contentType === "formData" ? data : data,
    })
      .then(async (response) => {
        setLoader(false);
        if (response.status === 401) {
          fetch(`${process.env.REACT_APP_BASE_URL}/api/Auth/Refresh`, {
            method: "POST",
            mode: "cors",
            headers: {
              Authorization: `Bearer ${token?.accessToken}`,
              //AppName: "admin",
              Accept: "application/json, text/plain",
              "Content-Type": "application/json;charset=UTF-8",
            },
            body: JSON.stringify(token),
          })
            .then(async (response) => {
              ClearUserData();

              const responseData = await response.json();

              if (responseData.ok) {
                setToken(responseData.data);
                //ParseJwt(responseData.data?.accessToken);
                localStorage.setItem(
                  "token",
                  JSON.stringify(responseData.data)
                );
                localStorage.setItem(
                  "accessToken",
                  responseData.data.accessToken
                );
                localStorage.setItem(
                  "refreshToken",
                  responseData.data.refreshToken
                );

                setIsLoggedIn(true);
                setIsAdmin(true);
              }
            })
            .catch((error) => {});
          return { ok: false };
        }
        if (response.status === 403) {
          confirmDialog({
            header: "Uyarı",
            defaultFocus: "accept",
            closable: false,
            closeIcon: false,
            message: (
              <div className="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
                <i className="pi pi-exclamation-circle text-6xl text-primary-500"></i>
                <span>Yetkiniz bulunmamaktadır.</span>
              </div>
            ),
            footer: (opts) => {
              return (
                <>
                  <div className="">
                    <Button onClick={opts.accept} label="Tamam"></Button>
                  </div>
                </>
              );
            },
            accept() {
              ClearUserData();
            },
            reject() {},
          });
          return response;
        }
        // console.log("XXresponse: ", response);
        const responseData = await response.json();
        // console.log("XXresponseData: ", responseData);
        if (responseData !== undefined) {
          if (responseData.statusCode === 200) return responseData;
          else if (responseData.statusCode === 406) {
            toast.current.show({
              severity: "info",
              summary: "Bilgi",
              detail:
                responseData.errors && responseData.errors.title
                  ? responseData.errors.title
                  : responseData.errorMessage,
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Hata",
              detail:
                responseData.errors && responseData.errors.title
                  ? responseData.errors.title
                  : responseData.errorMessage,
              life: 8000,
            });
            return responseData;
          }
        } else {
          toast.current.show({
            severity: "error",
            summary: "Hata",
            detail: `${response.status} ${response.statusText}`,
            life: 8000,
          });
          return { ok: false };
        }
      })
      .catch((error) => {
        setLoader(false);
        toast.current.show({
          severity: "error",
          summary: "Hata",
          detail: `Serviste hata oluştu, üzerinde çalışıyoruz...`,
          life: 8000,
        });

        return { ok: false };
      });
  };

  const AdminLoginHandler = async (data: BodyInit | null | undefined) => {
    // console.log("inside adminLoginHandler");
    // console.log("data: ", data);
    const response = await FetchHandler(
      "Auth/Login",
      "post",
      null,
      data,
      "admin"
    );
    // console.log("response: ", response);

    if (response.statusCode === 200) {
      setToken(response.data);
      //ParseJwt(response.data.accessToken);
      localStorage.setItem("token", JSON.stringify(response.data));
      localStorage.setItem("accessToken", response.data.accessToken);
      localStorage.setItem("refreshToken", response.data.refreshToken);
      setIsLoggedIn(true);
      // console.log("isAdmin: ", isAdmin);
      // console.log("isLoggedIn: ", isLoggedIn);
      setIsAdmin(true);
      //!isAdmin && window.location.replace("/admin");
    } else if (response.statusCode === 403) {
      toastTopCenter.current.show({
        severity: "error",
        summary: "Hata",
        detail: response.errorMessage,
        sticky: true,
      });
      return response;
    } else {
      toastTopCenter.current.show({
        severity: "error",
        summary: "Hata",
        detail: response.errorMessage,
        sticky: true,
      });

      return response;
    }
  };

  const LogoutHandler = () => {
    ClearUserData();
  };

  const ClearUserData = () => {
    // console.log("aa");
    localStorage.removeItem("token");
    setToken(null);
    setIsLoggedIn(false);
    setIsAdmin(false);
    setUserRole(null);
    navigate("/admin");
  };

  return (
    <AppContext.Provider
      value={{
        isLoggedIn: isLoggedIn,
        isAdmin: isAdmin,
        isMobile: isMobile,
        loader: loader,
        setLoader: setLoader,
        token: token,
        user: user,
        toast: toast,
        toastTopCenter: toastTopCenter,
        toastCenter: toastCenter,
        companies: companies,
        companySubs: companySubs,
        locations: locations,
        departments: departments,
        titles: titles,
        users: users,
        readers: readers,
        leaveTypes: leaveTypes,
        userRole: userRole,
        setUserRole: setUserRole,

        IsLoggedInAsync: IsLoggedInAsync,
        AdminLoginHandler: AdminLoginHandler,
        LogoutHandler: LogoutHandler,
        FetchHandler: FetchHandler,
        GetCompanies: GetCompanies,
        GetCompanySubs: GetCompanySubs,
        GetLocations: GetLocations,
        GetDepartments: GetDepartments,
        GetTitles: GetTitles,
        GetUsers: GetUsers,
        GetReaders: GetReaders,
        GetLeaveTypes: GetLeaveTypes,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};
